"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var temp = function UsbTwoTone(primaryColor, secondaryColor) {
    return {
        name: 'usb',
        theme: 'twotone',
        nameWithTheme: 'usb-twotone',
        tag: 'svg',
        attrs: {
            xmlns: 'http://www.w3.org/2000/svg',
            class: 'icon',
            viewBox: '0 0 1024 1024'
        },
        children: [
            {
                tag: 'path',
                attrs: {
                    fill: secondaryColor,
                    d: 'M759.9 504H264.1c-26.5 0-48.1 19.7-48.1 44v292h592V548c0-24.3-21.6-44-48.1-44z'
                },
                children: []
            },
            {
                tag: 'path',
                attrs: {
                    d: 'M456 248h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm160 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z',
                    fill: primaryColor
                },
                children: []
            },
            {
                tag: 'path',
                attrs: {
                    d: 'M760 432V144c0-17.7-14.3-32-32-32H296c-17.7 0-32 14.3-32 32v288c-66.2 0-120 52.1-120 116v356c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8V548c0-63.9-53.8-116-120-116zM336 184h352v248H336V184zm472 656H216V548c0-24.3 21.6-44 48.1-44h495.8c26.5 0 48.1 19.7 48.1 44v292z',
                    fill: primaryColor
                },
                children: []
            }
        ]
    };
};
temp.nameWithTheme = 'usb-twotone';
var UsbTwoTone = temp;
exports.default = UsbTwoTone;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@1.0.0@@ant-design/icons/lib/twotone/UsbTwoTone.js
// module id = 969
// module chunks = 0 1